import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "angle-solid-down",
  "use": "angle-solid-down-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" xmlns=\"http://www.w3.org/2000/svg\" id=\"angle-solid-down\">\n    <path d=\"M5 6L10 0H0L5 6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol